// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".google-pay-btn{display:flex;align-items:center;justify-content:center;min-width:200px;height:40px;min-height:40px;border-radius:4px;margin-left:6px;background-color:#fff;cursor:pointer}.google-pay-btn--disabled{opacity:.3;cursor:not-allowed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
